import React, { Component } from 'react';
import styled from 'styled-components';

import { WHITE, TEXT, PRIMARY, ERROR } from '../constants/colors';

const typeToColor = (type) => {
  switch (type) {
    case 'primary': return WHITE;
    case 'secondary': return TEXT;
    case 'error': return WHITE;
    default: return TEXT;
  }
};

// const typeToColorHover = (type) => {
//   switch (type) {
//     case 'primary': return WHITE;
//     case 'secondary': return WHITE;
//     case 'error': return ERROR;
//     default: return TEXT;
//   }
// };

const typeToBackground = (type) => {
  switch (type) {
    case 'primary': return PRIMARY;
    case 'secondary': return WHITE;
    case 'error': return ERROR;
    default: return WHITE;
  }
};

// const typeToBackgroundHover = (type) => {
//   switch (type) {
//     case 'primary': return PRIMARY_DARK;
//     case 'secondary': return PRIMARY;
//     case 'error': return WHITE;
//     default: return WHITE;
//   }
// };

const typeToBorder = (type) => {
  switch (type) {
    case 'primary': return PRIMARY;
    case 'secondary': return TEXT;
    case 'error': return ERROR;
    default: return TEXT;
  }
};

// const typeToBorderHover = (type) => {
//   switch (type) {
//     case 'primary': return PRIMARY_DARK;
//     case 'secondary': return PRIMARY;
//     case 'error': return ERROR;
//     default: return TEXT;
//   }
// };

const ButtonWrapper = styled.button`
  outline: none;
  font-size: 12px;
  padding: 5px 15px;
  margin-bottom: 10px;
  border-radius: 3px;
  width: ${(props) => props.block ? '100%' : 'auto'};
  color: ${(props) => typeToColor(props.type)};
  background-color: ${(props) => props.disable ? '#ccc' : typeToBackground(props.type)};
  border: 1px solid ${(props) => props.disable ? '#ccc' : typeToBorder(props.type)};
  cursor: pointer;
  pointer-events: ${(props) => props.disable ? 'none' : 'auto'};
  display: flex;
  justify-content: center;

  > img {
    width: 12px;
  }
`;

export class Button extends Component {
  render() {
    const {
      type = 'primary', children, onClick, block = false, disable = false,
    } = this.props;

    return (
      <ButtonWrapper
        block={block}
        disable={disable}
        onClick={disable ? () => null : onClick} // eslint-disable-line
        type={type}
      >
        {children}
      </ButtonWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button.js